<template>
  <div class="cherkizovo-card-part-manual">
    <div
      v-for="partIndex in 3"
      :key="partIndex"
      class="cherkizovo-card-part-manual__col"
    >
      <div class="cherkizovo-card-part-manual__label">{{ partLabels[partIndex] }}</div>
      <el-input
        v-model="scope.row.scale.current_scale_part['part_' + partIndex]"
        :disabled="!isFieldAvailableForEdit(scope.row, 'scale.current_part_id')"
        type="textarea"
        class="cherkizovo-card-part-manual__input"
        @change="changed(scope, 'part_' + partIndex, $event)"
      />
    </div>
  </div>
</template>

<script>
import requestSender from '@/api/base/requestSender';
import { ElementPropTableColumn } from '@/mixins/elementPropTableColumn';

export default {
  name: 'cherkizovo-card-part-manual',
  mixins: [ElementPropTableColumn],
  props: {
    scope: { type: Object, required: true },
  },
  data() {
    return {
      partLabels: {
        1: 'Уровень 1 (канал, направление)',
        2: 'Уровень 2 (площадка, регион)',
        3: 'Уровень 3 (сегмент, продукт)',
      },
    };
  },
  methods: {
    changed(scope, name, value) {
      requestSender('post', 'scale/update-single-part-for-card-element', {
        element_id: scope.row.id,
        name,
        value,
      })
        .then(() => {
          this.$notify.success({ title: 'Сохранено', message: 'Элемент успешно сохранен' });
        })
        .finally(() => {
          this.$emit('elements-changed');
        });
    },
  },
};
</script>

<style scoped lang="scss">
.cherkizovo-card-part-manual {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;

  &__col {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__label {
    font-size: 11px;
    font-weight: 500;
    color: #909399;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
  }

  &__input {
    flex: 1;

    // Make the inner textarea fill the column
    :deep(.el-textarea__inner) {
      height: 100%;
      resize: none;
    }
  }
}
</style>
